export default "__VITE_ASSET__d7338493__"